import { render, staticRenderFns } from "./LabelModal1.vue?vue&type=template&id=4d5b5485&scoped=true&"
import script from "./LabelModal1.vue?vue&type=script&lang=js&"
export * from "./LabelModal1.vue?vue&type=script&lang=js&"
import style0 from "./LabelModal1.vue?vue&type=style&index=0&id=4d5b5485&prod&lang=scss&scoped=true&"
import style1 from "./LabelModal1.vue?vue&type=style&index=1&id=4d5b5485&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5b5485",
  null
  
)

export default component.exports